import { t } from '@avalara/bat-apps-shared/i18n';
import { SAlert, SCol, SRow } from '@avalara/skylab-sdk/react';
import { useSelector } from 'react-redux';

import styled from 'styled-components';

import { selectState } from '../../../selectors';
import { purchaseDeflectionWording } from '../../helpers';

const PaymentTextWrapper = styled.div`
  font-size: 16px;
  > s-alert {
    position: relative;
    margin-bottom: 20px;
  }
`;

const PaymentText = () => {
  const {
    account: { isAdmin, isLoggedIn },
  } = useSelector(selectState);

  return (
    <PaymentTextWrapper>
      {isLoggedIn && isAdmin === false ? (
        <SAlert status='warning' noDismiss>
          <div>{purchaseDeflectionWording}</div>
        </SAlert>
      ) : (
        <SRow>
          <SCol span='9'>
            <p>{t('client.general.your-payment-method-will-be-used-for-automatic-payment-of-al')}</p>
            <br />
            <p className='font-semibold'>{t('client.general.keep-in-mind')}:</p>
            <p>
              {"You're authorizing us to process payment using your payment method. "}
              {'We will automatically charge your payment method on the invoice due date. '}
              {t('client.general.you-can-update-your-payment-method-at-any-time')}
            </p>
          </SCol>
        </SRow>
      )}
    </PaymentTextWrapper>
  );
};
export default PaymentText;
